/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { createContext } from 'react';

import { TAllocationContext, TPlansContext, TReplicaContext } from './types';

export const ReplicaContext = createContext<TReplicaContext>({} as TReplicaContext);

export const AllocationContext = createContext<TAllocationContext>({} as TAllocationContext);

export const PlansContext = createContext<TPlansContext>({} as TPlansContext);
